export default {"src":"/_next/static/media/gift_40.113d91dc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};